// First path segments that belong to the site, never to a member's profile.
//
// streamnook.app/<twitch @> is a member's page, so every word the site uses (or
// may use) as a top-level path must be listed here, or a member with that Twitch
// @ would take it over. scripts/check-reserved-slugs.mjs fails the build when a
// function, a public file or an App.tsx route is missing from this list.
//
// Before adding a word, check `users.username` for a member who already has it:
// that member's page then lives at /u/<login> instead (profileUrl does this), so
// tell them, or pick another word.
//
// Shared by the client and the Pages Functions; keep it dependency free.

export const RESERVED_SLUGS: ReadonlySet<string> = new Set([
  // Pages Functions directories and files
  'api',
  'download',
  'downloads',
  'fdroid',
  'obtainium',
  'og',
  'support',
  'u',
  'w',
  // public/ folders
  'assets',
  'cosmetics',
  'emotes',
  'fonts',
  'seasonal',
  'shots',
  // SPA routes
  'profile',
  'admin',
  'account',
  'overlays',
  'overlay',
  'bots',
  'penrose',
  'plugins',
  'status',
  'auth',
  'discord',
  'checkout',
  'events',
  'dashboard',
  // Held for later
  'd',
  'go',
  'l',
  'link',
  'links',
  'settings',
  'login',
  'logout',
  'signin',
  'signout',
  'signup',
  'register',
  'help',
  'faq',
  'terms',
  'tos',
  'privacy',
  'legal',
  'about',
  'blog',
  'docs',
  'app',
  'apps',
  'www',
  'cdn',
  'static',
  'media',
  'img',
  'images',
  'explore',
  'discover',
  'search',
  'templates',
  'pricing',
  'premium',
  'membership',
  'members',
  'member',
  'users',
  'user',
  'me',
  'new',
  'edit',
  'home',
  'index',
  'root',
  'null',
  'undefined',
  'streamnook',
  'staff',
  'mod',
  'mods',
  'moderator',
  'official',
  'team',
  'contact',
  'abuse',
  'report',
  'security',
  'press',
  'shop',
  'store',
  'gift',
  'gifts',
  'redeem',
  'claim',
  'invite',
  'embed',
  'widget',
  'widgets',
]);

/** True when a first path segment belongs to the site (any case). */
export function isReservedSlug(segment: string): boolean {
  return RESERVED_SLUGS.has(segment.toLowerCase());
}
